import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function CrearNoticia() {
  const [formData, setFormData] = useState({
    type: 'ROSTERS', // Valor por defecto para evitar envío vacío
    title: '',
    body: ''
  });
  const [imageUrls, setImageUrls] = useState(['']); // Comenzamos con un campo vacío
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleAddImageField = () => {
    if (imageUrls.length < 5) {
      setImageUrls([...imageUrls, '']);
    } else {
      alert('Máximo 5 imágenes permitidas');
    }
  };

  const handleRemoveImageField = (index) => {
    const newImageUrls = [...imageUrls];
    newImageUrls.splice(index, 1);
    setImageUrls(newImageUrls);
  };

  const handleImageUrlChange = (index, value) => {
    const newImageUrls = [...imageUrls];
    newImageUrls[index] = value;
    setImageUrls(newImageUrls);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Filtrar URLs vacías
    const filteredImageUrls = imageUrls.filter(url => url.trim() !== '');
    
    if (filteredImageUrls.length === 0) {
      setError('Debe proporcionar al menos una URL de imagen');
      setLoading(false);
      return;
    }

    try {
      const newsData = {
        ...formData,
        images: filteredImageUrls
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/news`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newsData),
        credentials: 'include', // Para manejar cookies de sesión si las hay
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `Error ${response.status}: ${response.statusText}`
        }));
        throw new Error(errorData.error || 'Error al crear la noticia');
      }

      const data = await response.json();
      
      if (data.success) {
        alert('¡Noticia creada exitosamente!');
        navigate('/noticias');
      } else {
        throw new Error(data.error || 'Error desconocido al crear la noticia');
      }
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || 'Error al crear la noticia');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark py-12">
      <div className="max-w-2xl mx-auto px-4">
        <h1 className="text-4xl text-brand-white font-morganite mb-8">Crear Nueva Noticia</h1>
        
        {error && (
          <div className="bg-red-500/10 border border-red-500 text-red-500 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <select
              value={formData.type}
              onChange={(e) => setFormData({...formData, type: e.target.value})}
              className="w-full p-3 rounded-lg bg-brand-dark/50 text-brand-white border border-brand-red/20"
              required
            >
              <option value="ROSTERS">ROSTERS</option>
              <option value="COLABORACIONES">COLABORACIONES</option>
              <option value="MERCHANDISING">MERCHANDISING</option>
            </select>
          </div>

          <div>
            <input
              type="text"
              placeholder="Título de la noticia"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              className="w-full p-3 rounded-lg bg-brand-dark/50 text-brand-white border border-brand-red/20"
              required
            />
          </div>

          <div>
            <textarea
              placeholder="Contenido de la noticia"
              value={formData.body}
              onChange={(e) => setFormData({...formData, body: e.target.value})}
              className="w-full p-3 rounded-lg bg-brand-dark/50 text-brand-white border border-brand-red/20 h-48"
              required
            />
          </div>

          <div className="border-2 border-dashed border-brand-red/20 rounded-lg p-4">
            <h3 className="text-brand-white mb-3">URLs de imágenes (subidas previamente)</h3>
            <p className="text-brand-white/70 text-sm mb-4">
              Ejemplo: https://srv1665-files.hstgr.io/fe815abbc021867e/files/public_html/uploads/noticias/imagen.png
            </p>
            
            {imageUrls.map((url, index) => (
              <div key={index} className="flex items-center gap-2 mb-3">
                <input
                  type="text"
                  placeholder="URL de la imagen"
                  value={url}
                  onChange={(e) => handleImageUrlChange(index, e.target.value)}
                  className="flex-1 p-3 rounded-lg bg-brand-dark/50 text-brand-white border border-brand-red/20"
                  required
                />
                <button
                  type="button"
                  onClick={() => handleRemoveImageField(index)}
                  className="p-2 rounded-lg bg-red-500/20 text-red-500 hover:bg-red-500/30"
                >
                  X
                </button>
              </div>
            ))}
            
            {imageUrls.length < 5 && (
              <button
                type="button"
                onClick={handleAddImageField}
                className="w-full p-2 rounded-lg border border-dashed border-brand-red/30 text-brand-white/70 hover:bg-brand-red/10"
              >
                + Agregar otra imagen
              </button>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-brand-red text-brand-white font-medium 
                     hover:bg-brand-red/90 transition-all duration-200 disabled:opacity-50"
          >
            {loading ? 'Creando...' : 'Crear Noticia'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CrearNoticia;